// extracted by mini-css-extract-plugin
export default {"subcategory":"subcategory__wagM7","subcategorySection":"subcategorySection__SigZG","subcategoryCompleted":"subcategoryCompleted__pUmOA","addGift":"addGift__JxL5_"};